<template>
  <div>
    <v-container
      v-if="!togglePlanPage"
      class="page__wrapper"
      style="position: relative"
    >
      <v-btn
        icon
        style="position: absolute; top: 10px; left: 10px"
        @click="back"
      >
        <v-icon color="primary" style="font-size: 45px"
          >mdi-chevron-left</v-icon
        >
      </v-btn>
      <template>
        <h3 class="mt-5 mb-5">
          {{ $t('Step') }} 5 : {{ $t('Edit menu bar label') }}
        </h3>
      </template>
      <template>
        <!-- <v-stage
          :config="templateSelect.size"
          ref="stage"
          class="text-center preview-img setPadding mt-5 mb-5"
        >
          <v-layer
            v-for="(area, index) in templateSelect.areas"
            :key="index"
            @click="editBound(area, index)"
          >
            <v-rect :config="area.bounds"></v-rect>
            <v-image
              :config="{
                x: area.bounds.x,
                y: area.bounds.y,
                width: area.bounds.width,
                height: area.bounds.height,
                image: image[index],
              }"
            />
          </v-layer>
        </v-stage> -->
        <preview-template
          v-model="templateSelect.content_json.chatBarText"
        ></preview-template>
      </template>

      <validation-observer ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="showDialog">
          <template
            ><h4 class="mt-3 mb-2">
              {{ $t('Menu bar label') }} <span class="color-red">*</span>
            </h4>
            <validation-provider
              v-slot="{ errors }"
              :name="$t('Menu bar label')"
              :rules="{
                required: true
              }"
            >
              <v-text-field
                v-model="templateSelect.content_json.chatBarText"
                :counter="14"
                :maxlength="14"
                dense
                outlined
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <div class="text-center">
              <v-btn
                x-small
                outlined
                color="primary"
                rounded
                class="mb-2"
                @click="showAdvance = !showAdvance"
              >
                Advance
                <v-icon x-small>{{
                  !showAdvance ? 'mdi-chevron-down' : 'mdi-chevron-up'
                }}</v-icon>
              </v-btn>
            </div>
            <template v-if="showAdvance">
              <h4 class="mt-3 mb-3">{{ $t('Default behavior') }}</h4>
              <v-radio-group
                v-show="false"
                v-model="templateSelect.content_json.selected"
                mandatory
              >
                <v-radio label="Shown" :value="true"></v-radio>
                <v-radio label="Collapsed" :value="false"></v-radio>
              </v-radio-group>
              <div style="display: inline-flex">
                <v-btn
                  outlined
                  rounded
                  class="mr-5"
                  :class="
                    templateSelect.content_json.selected
                      ? 'btn-color-set'
                      : 'default-btn-color'
                  "
                  @click="templateSelect.content_json.selected = true"
                >
                  {{ $t('Shown') }}</v-btn
                >
                <v-btn
                  outlined
                  rounded
                  :class="
                    templateSelect.content_json.selected
                      ? 'default-btn-color'
                      : 'btn-color-set'
                  "
                  @click="templateSelect.content_json.selected = false"
                >
                  {{ $t('Collapsed') }}</v-btn
                >
              </div>
            </template>
          </template>

          <!-- <template>
            <div class="btn-sticky mt-5 pr-pl-12">
              <v-btn outlined @click="back" class="btn-back-richmenu w45 br-7">Back</v-btn>
              <v-btn
                outlined
                class="btn-custom btn-next-richmenu w45 right"
                :disabled="invalid"
                type="submit"
                ><span>Save</span>
              </v-btn>
            </div>
          </template> -->
          <template>
            <v-card class="command-bar">
              <div
                class="btn-sticky mt-5 pr-pl-12 sticky-left"
                style="z-index: 1"
              >
                <v-btn
                  outlined
                  class="btn-custom right btn-custom-outline-color"
                  :href="how_to_use_blog"
                  target="blank"
                  depressed
                  rounded
                >
                  <v-icon>mdi-help-circle</v-icon
                  ><span class="ml-1"> {{ $t('How to use') }}</span>
                </v-btn>
              </div>
              <div
                class="btn-sticky mt-5 pr-pl-12 sticky-right"
                style="z-index: 1"
              >
                <!-- <v-btn
                outlined
                @click.native="$router.push('/richmenu')"
                class="btn-back-richmenu br-7 mr-5"
                style="width: 180px;"
                >Choose Template</v-btn
              > -->
                <v-btn
                  outlined
                  class="btn-custom btn-next-richmenu right"
                  style="width: 180px"
                  :disabled="invalid"
                  type="submit"
                  ><span>{{ $t('save_and_next') }}</span>
                </v-btn>
              </div>
            </v-card>
          </template>
        </form>
      </validation-observer>

      <payment-plan
        v-if="dialog"
        v-model="dialog"
        @toggleToPagePlan="toggleToPagePlan"
      ></payment-plan>
    </v-container>
    <packages-plan v-else></packages-plan>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PreviewTemplate from './PreviewTemplate'
import PaymentPlan from './PaymentPlan'
import PackagesPlan from '../../views/PackagesPlan'
import configUrl from '@/config'
export default {
  components: {
    PackagesPlan,
    PaymentPlan,
    PreviewTemplate
  },
  data() {
    return {
      dialog: false,
      togglePlanPage: false,
      showAdvance: false,
      how_to_use_blog: configUrl.how_to_use_blog
    }
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      clickTrial: 'lineRichmenuManager/getClickTrial'
    })
  },
  methods: {
    toggleToPagePlan() {
      this.togglePlanPage = true
    },

    async showDialog() {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      this.$gtag.event('event', {
        event_category: prefix + 'Step 5 Edit menu bar label next'
        // event_label: bot.pagename + utm,
      })
      // console.log(this.templateSelect);
      // this.$store.dispatch("lineRichmenuManager/setTemplateSelect", this.templateSelect);
      var res = await this.$store.dispatch(
        'lineRichmenuManager/putTemplateSelect',
        this.templateSelect
      )
      if (res && !res._isError) {
        // console.log(res);
        if (this.clickTrial) {
          this.dialog = true
        } else {
          this.$emit('goToPage', 8)
        }
      } else {
        let title = 'Error'
        let text = `something went wrong, please try again.`

        if (res && res._isError && res.error) {
          const errData = res.error
          if (errData.message && errData.message.includes('error(s)')) {
            let hasUriError = false
            if (errData.details && errData.details.length > 0) {
              errData.details.forEach(detail => {
                if (detail.message.includes('invalid uri')) {
                  hasUriError = true
                }
              })
            }
            if (hasUriError) {
              title = this.$t('Error_With_Colon')
              text = this.$t('invalid_url_message')
            }
          }
        }

        this.$notify({
          group: 'foo',
          type: 'error',
          title: title,
          text: text
        })
      }
    },
    back() {
      this.$emit('goToPage', 5)
    }

    // behaviorSet() {
    //   this.templateSelect.content_json.selected =
    //   this.$store.dispatch("lineRichmenuManager/setTemplateSelect", this.templateSelect);
    // },
  }
}
</script>

<style lang="scss" scoped>
.default-btn-color {
  border-width: 2px;
  font-weight: 500;
  border-color: #b4b4b4;
  color: #b4b4b4;
}

.btn-color-set {
  border-width: 2px;
  font-weight: 500;
  border-color: var(--primary-color) !important;
  color: var(--primary-color) !important;
}
</style>
